import { getEnvironments, Environment } from "@api";
import { FilterType, Table } from "@components";
import { Cell, Row } from "@components/table/types";
import { Box, Grid, Button, Typography, IconButton } from "@material-ui/core";
import * as React from "react";
import { useState } from "react";
import { M_TABLE_HEADERS_ENVIRONMENT } from "../constants";
import { useHistory } from "react-router-dom";
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import { Envdetails } from "./detail";
import { MaintenanceBreadcrumbs } from "../breadcrumbs";

const headers: Cell[] = [
  { data: M_TABLE_HEADERS_ENVIRONMENT.NAME },
  { data: M_TABLE_HEADERS_ENVIRONMENT.IS_ACTIVE },
];

const formatBool = (status: boolean): string => {
  return status ? "Yes" : "No";
};

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

type FormValues = {
  name: string;
  isActive: boolean;
};

export type SelectedItem = {
  selectedEnv: Environment;
};

type Key = keyof FormValues;

export const Environments: React.FC = () => {
  const history = useHistory();
  const [environmentList, setEnvironment] = useState<Environment[]>([]);
  const [isLoading, setIsloading] = useState<boolean>(true);
  const [open, setOpen] = React.useState<boolean>(false);
  const [selectedItem, setSelectedEnv] = React.useState<
    Environment | undefined
  >(undefined);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const updateData = () => {
    incrementCounter();
  };

  const handleClose = () => {
    setSelectedEnv(undefined);
    setOpen(false);
  };

  const styles = (theme: Theme) =>
    createStyles({
      root: {
        margin: 0,
        padding: theme.spacing(2),
      },
      closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
      },
    });

  const [counter, updateCounter] = React.useState(0);
  React.useEffect(() => {
    getEnvironments()
      .then((envResponse: Environment[]) => {
        console.log(envResponse);
        setEnvironment(envResponse);
        setIsloading(false);
      })
      .catch((err: any) => {
        console.error("there was an errror", err);
      });
  }, [counter]);

  const incrementCounter = () => {
    updateCounter(counter + 1);
  };

  let editModal = null;
  if (!!selectedItem) {
    editModal = (
      <Envdetails
        id={0}
        data={selectedItem}
        isOpen={open}
        onClickAdd={updateData}
        onClickClose={handleClose}
      />
    );
  }

  const pageName = "Environments";
  return (
    <Box mt={2}>
      <MaintenanceBreadcrumbs title={pageName} />
      {editModal}
      <Table
        data={environmentList.map((env: Environment) => ({
          cells: [
            {
              data: env.name,
              color: "blue",
              cursor: "pointer",
              onClick: () => {
                setSelectedEnv(env);
                setOpen(true);
              },
            },
            { data: formatBool(env.isActive) },
          ],
          data: env,
        }))}
        tableName={pageName}
        searchPlaceholder="Search by Name"
        searchColumns={[M_TABLE_HEADERS_ENVIRONMENT.NAME]}
        headers={headers}
        filters={[FilterType.SORT, FilterType.SEARCH, FilterType.PAGINATOR]}
        toolbar="M_ENVIRONMENT_TOOLBAR"
        onClickAdd={updateData}
        loading={isLoading}
      />
    </Box>
  );
};
